import React from "react";

const PageHero = ({ title, subtitle }) => {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0d6efd, #6610f2)",
        padding: "70px 20px",
        textAlign: "center",
        color: "#fff"
      }}
    >
      <h1 style={{ fontSize: "42px", fontWeight: "700" }}>{title}</h1>
      {subtitle && (
        <p style={{ fontSize: "18px", marginTop: "10px", opacity: 0.9 }}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default PageHero;